import Store from 'store/store';

export const levels = [
	{
		type: 'necessary',
		name: 'Strictly Necessary Cookies',
		description: 'These are all the cookies without which the website could not perform basic functions.',
		required: true
	},
	{
		type: 'performance',
		name: 'Performance Cookies',
		description: 'These cookies are used to provide site owners with statistical information about their site – which is generally used for performance measurement and improvement.',
	},
	{
		type: 'functionality',
		name: 'Functionality Cookies',
		description: 'These cookies are generally there to support site functionality that is visible or advantageous to the user or their experience of the site.',
	},
	{
		type: 'targetting',
		name: 'Targeting or Advertising Cookies',
		description: 'These types of cookies are set by digital advertising businesses for the prime or sole purpose of managing the performance of adverts, displaying adverts, and/or building user profiles to determine the display of adverts elsewhere.',
	},
];
const types = levels.map(e => e.type);

const handlers = [];

export const getActiveLevels = () => {
	return levels.filter(level => level.required || handlers.find(el => el.level === level.type)).map(e => e.type);
};

const triggerHandler = (handler) => {
	if (handler.triggered) {
		return;
	}
	handler.triggered = true;
	try {
		handler.fn();
	} catch(e) {
		console.log('Error executing cookie handler', e);
	}
};

export const register = (level, fn) => {
	if (!types.includes(level)) {
		throw new Error('Unregonized cookie level ' + level + ' - needs to be one of ' + types.join(', '));
	}
	if (typeof fn !== 'function') {
		throw new Error('A function is needed to register a cookie listener');
	}
	const handler = { level, fn, triggered: false };
	handlers.push(handler);
	try {
		if (Store.get().cookies.allowed[level]) {
			triggerHandler(handler);
		}
	} catch(e) {}
	Store.emit('COOKIE_REGISTERED');
};

export const trigger = (levels) => {
	handlers.forEach(handler => {
		if (levels[handler.level]) {
			triggerHandler(handler);
		}
	});
};

const localStorageName = 'powster-cookie-levels';
export const persist = values => {
	try {
		localStorage.setItem(localStorageName, JSON.stringify(values));
	} catch(e) {}
};
export const load = () => {
	let values = {};
	try {
		values = JSON.parse(localStorage.getItem(localStorageName));
	} catch(e) {}
	return values;
};
